// extracted by mini-css-extract-plugin
export var clamp = "BetNowCta-module--clamp--789e8";
export var copy = "BetNowCta-module--copy--729a5";
export var cta = "BetNowCta-module--cta--a4bd0";
export var flexbox = "BetNowCta-module--flexbox--a21e9";